import { CobrandModuleContentType, CommonListData, NavigateRoutes, TransactionModule } from 'common/constants/app.constant';
import { BaseDataModel, FormMetaModel } from 'common/models/utilitymodels/base.model';
import { HeadersList, ListMetaModel, ListModel } from 'common/models/utilitymodels/list.model';

export type cobrandingSort = 'oldToNew' | 'newToOld' | '';
export type cobrandingContentType = 'PDF' | 'IMAGE' | 'VIDEO' | 'HTML' | 'GIF' | 'ALL' | '';
export type cobrandingbucketType = '1' | '2' | '3';

export class CoBrandingApiQueryParams {
    bucketType: cobrandingbucketType = '1';
    contentType: cobrandingContentType | null = null;
    pageNumber: number = 1;
    pageSize: number = CommonListData.coBrandingPerPage;
    schemeId: number | null = null;
    sorting: cobrandingSort = '';
    userId: number = 0;
    search: string | null = null;
}

export class CoBrandingDataModel extends BaseDataModel {
    name: '';
    type: '';
    link: '';
    isNew: boolean = false;
    scheme: string = '';
    created_at: Date = new Date();
    upadated_at: Date = new Date();
}

export class CoBrandingListingModel extends ListModel<CoBrandingDataModel> {
    filterSchemeValueList: any[] = [];
    selectedScheme: any = null;
    selectedContentType: cobrandingContentType | null = 'ALL';
    selectedBucketType: cobrandingbucketType = '1';
    selectedSorting: cobrandingSort | null = 'newToOld';
    selectedShareItem: any = null;
    userId: any = 0;
}

export class CoBrandingMetaModel extends ListMetaModel<HeadersList> {
    cobrandModuleContentType = CobrandModuleContentType;
    showLeftArrow = false;
    showRightArrow = false;
    constructor() {
        super('Co-Branding', '', true, CommonListData.rowPerPage, NavigateRoutes.distributordashboard);
    }
    prepareHeaderList(): HeadersList[] {
        const headers: HeadersList[] = [];
        const name = new HeadersList('name', 'name', true, false, 'text');
        headers.push(name);
        return headers;
    }

    initProperties(): any {
        const dataInfo = {
            isEditable: this.isEditable,
            recordPerPage: this.recordPerPage,
            listInfo: this.prepareHeaderList(),
            pointer: undefined,
            isSortOpen: false,
            isFilterOpen: false,
            showLeftArrow: this.showLeftArrow,
            showRightArrow: this.showRightArrow,
            currentTableDropdownId: null,
            contentType: this.cobrandModuleContentType,
            userProfile: {},
        };
        return dataInfo;
    }
}
